import styled from 'styled-components';
import * as Semantic from 'semantic-ui-react';

export const SaveMenuItem = styled(Semantic.Menu.Item)<{ disabled: boolean }>`
    background: #21ba45 !important;
    color: white !important;
    opacity: ${(p) => p.disabled && '.45'} 
`;
